'use strict';
var notificationsService = require('../../modules/utils/notifications').notificationService();
var trackingUtils = require('../../modules/utils/tracking.utils');
Odigeo.defineWidget('browser_notification_popup', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        events: {
            'tap @acceptNotification': 'onAcceptNotification',
            'tap @dismissNotification': 'onDismissNotification',
            'tap @closePopup': 'onClosePopupClick',
        },

        selectors: {
            notificationsBox: '.notification_popup',
            acceptNotification: '.accept_notification',
            dismissNotification: '.dismiss_notification',
            closePopup: '.close_notification_popup',
        },

        init: function() {
            this.listenTo(this.model, 'change:showed', Odigeo._.bind(this.renderPopup, this));
        },

        closePopUp: function(label) {
            trackingUtils.trackEvent('browser_notification', 'browser_notification_accept_' + label);
            this.removePopup();
        },

        onAcceptNotification: function() {
            this.closePopUp('YES');
            notificationsService.requestPermission();
        },

        onDismissNotification: function() {
            this.closePopUp('NO');
        },

        onClosePopupClick: function() {
            this.closePopUp('close');
        },

        togglePopUp: function(show) {
            this.$cachedSelectors.notificationsBox.toggleClass('show', show);
        },

        removePopup: function() {
            this.togglePopUp(false);
            Odigeo._.delay(Odigeo._.bind(function() {
                this.$cachedSelectors.notificationsBox.remove();
            }, this), 500);
        },

        renderPopup: function() {
            this.$el.html(this.templates.popup(this.keys));
            this.updateDomSelectorsToCache();
            this.togglePopUp(true);
        },
    }),
    launchPopup: function() {
        if (Odigeo._.isUndefined(this.model.get('showed'))) {
            trackingUtils.trackEvent('browser_notification', 'browser_notification_accept_load');
            this.model.set('showed', true);
        }
    },
    endPopup: function() {
        this.view.removePopup();
    },
}));
